export { default as Tyres } from './Tyres';



// WEBPACK FOOTER //
// ./src/components/FormControls/Tyres/index.ts